import { Table } from "antd";
import { useQuery } from "react-query";
import DashboardMaster from "../dashboard/dashboard-master-layout.component";
import React, { ReactElement } from "react";
import { getPanelList } from "./panel.thunks";
import { tableColumns } from "../../lib/helpers.table";
import { PanelInterface } from "./panel.interface";
import { Link } from "react-router-dom";

const PanelList = (): ReactElement => {
  const moduleName = "panels"; // we will use this as both the query name and the delete API endpoint
  const [page, setCurrentPage] = React.useState(0);

  const { data } = useQuery(
    [moduleName, { page }],
    () => getPanelList({ page }),
    { keepPreviousData: true }
  );

  const tableData = data ? data.docs : [];

  const pagination = {
    current: data?.page,
    pageSize: data?.limit,
    hideOnSinglePage: true,
    showSizeChanger: false,
    total: data?.totalDocs,
    onChange: (page) => {
      pagination.current = page; // updates table pagination
      setCurrentPage(page); // re-fetch the api
    },
  };

  const columnData = [
    {
      title: "Size",
      dataIndex: "size",
      render: (text, doc) => (
        <Link to={`${moduleName}/` + doc._id}>
          {doc?.size?.height + "x" + doc?.size?.width}
        </Link>
      ),
    },
    "Sort",
  ];

  const columns = tableColumns(
    columnData,
    { field: "Title", url: `${moduleName}/` },
    { url: moduleName }
  );
  return (
    <>
      <DashboardMaster
        showAdd={true}
        title="Panels"
        addUrl={`/dashboard/${moduleName}/new`}
      >
        <Table
          rowKey={(doc: PanelInterface) => doc._id}
          columns={columns}
          dataSource={tableData}
          pagination={pagination}
        />
      </DashboardMaster>
    </>
  );
};

export default PanelList;
